var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<i class=\"fa fa-lg fa-pencil-square-o\" aria-hidden=\"true\"></i>\n<span class=\"form-comment\">\n<ng-transclude></ng-transclude> (valid: {{ $ctrl.nextGasDay | pkpTimestamp }})\n</span>\n</div>\n";
var id1="app/shipper-admin/inline-hint-future-version.component.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;